import type { AssetTypeTemplateSaveBarProps } from "./asset-type-template-save-bar.type";

import AppSaveBar from "@/modules/app-save-bar";

export const AssetTypeTemplateSaveBar = ({
  template,
  onCancel,
  onSave,
  loading,
}: AssetTypeTemplateSaveBarProps) => {
  return (
    <AppSaveBar
      date={template?.updated_at}
      onSave={onSave}
      onCancel={onCancel}
      loading={loading}
    />
  );
};
